/* Blog sidebar product slider — one product per slide, arrows + bullets. */
(function () {
  var SELECTOR = '[data-blog-sidebar-slider]';

  function init() {
    var sliders = document.querySelectorAll(SELECTOR);
    if (!sliders.length) return;

    if (typeof Swiper === 'undefined') {
      // Swiper failed to load — fall back to a horizontally scrollable row.
      for (var f = 0; f < sliders.length; f++) {
        sliders[f].classList.add('cp-sidebar__slider--fallback');
      }
      return;
    }

    for (var i = 0; i < sliders.length; i++) {
      var slider = sliders[i];
      if (slider.dataset.sliderReady === 'true') continue;
      slider.dataset.sliderReady = 'true';

      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 16,
        speed: 450,
        observer: true,
        observeParents: true,
        watchOverflow: true,
        a11y: { enabled: true },
        navigation: {
          prevEl: slider.querySelector('.cp-sidebar__slider-nav--prev'),
          nextEl: slider.querySelector('.cp-sidebar__slider-nav--next')
        },
        pagination: {
          el: slider.querySelector('.cp-sidebar__slider-pagination'),
          type: 'bullets',
          clickable: true
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
